import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import PartnerLogo from '../../components/Donation/PartnerLogo';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-items: space-between;
    margin-bottom: 0.5em;
`;

const ProgressBar = styled.div`
    margin-top: 14px;
    height: 8px;
    border-radius: 12px;
    background-color: #f1f1ee;
    flex: 1;
    display: flex;
    position: relative;
    width: 100%;
    overflow: hidden;
`;

const Progress = styled.div`
    border-radius: 12px;
    background-color: #ff245e;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 500ms ease-out;
    transform: translate3d(
        ${props => (props.percentage ? -(100 - props.percentage) : 0)}%,
        0,
        0
    );
`;

const LogoContainer = styled.div`
    margin-right: 2.18em;
`;

const MobileDetailsHeader = props => (
    <Container>
        <LogoContainer>
            <PartnerLogo
                logoUrl={props.partnerLogo}
                marginBottom={'0'}
                onClick={props.onPartnerClick}
            />
        </LogoContainer>
        <ProgressBar>
            <Progress percentage={props.progressPercentage} />
        </ProgressBar>
    </Container>
);

MobileDetailsHeader.propTypes = {
    partnerLogo: PropTypes.string.isRequired,
    progressPercentage: PropTypes.number,
    onPartnerClick: PropTypes.func
};

export default MobileDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/Donation/MobileDetailsHeader.jsx